export default "__VITE_ASSET__tA5_VJ5N__"